import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { STATES, getCitiesForState } from '../../data/locations';
import { useGeolocation } from '../../hooks/useGeolocation';
import './LocationSelector.css';

function LocationSelector({ location, onChange, error }) {
  const { t } = useTranslation();
  const loc = location || {};
  const city = loc.city || '';
  const state = loc.state || '';
  const pincode = loc.pincode || '';
  const cities = getCitiesForState(state);
  const [gettingLocation, setGettingLocation] = useState(false);
  const {
    lat,
    lng,
    loading: geoLoading,
    error: geoError,
    refresh,
  } = useGeolocation();
  const stateError = error && !state;
  const cityError = error && state && !city;

  const handleUseMyLocation = () => {
    setGettingLocation(true);
    refresh();
  };

  React.useEffect(() => {
    if (!gettingLocation || geoLoading || lat == null || lng == null) return;
    setGettingLocation(false);
    onChange({ ...loc, lat, lng });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gettingLocation, geoLoading, lat, lng]);

  return (
    <div className="locationSelector">
      <div className="locationSelectorRow">
        <div className="locationFieldWrap">
          <label htmlFor="ad-location-state">
            {t('createAd.state')} <span className="cf-req">*</span>
          </label>
          <select
            id="ad-location-state"
            value={state}
            onChange={(e) =>
              onChange({ ...loc, state: e.target.value, city: '' })
            }
            className={`input locationSelect${stateError ? ' cf-input--error' : ''}`}
          >
            <option value="">{t('createAd.selectState')}</option>
            {STATES.map((s) => (
              <option key={s} value={s}>
                {s}
              </option>
            ))}
          </select>
          {stateError && (
            <span className="cf-error">{t('createAd.pleaseSelectState')}</span>
          )}
        </div>
        <div className="locationFieldWrap">
          <label htmlFor="ad-location-city">
            {t('createAd.city')} <span className="cf-req">*</span>
          </label>
          <input
            id="ad-location-city"
            type="text"
            list="ad-location-city-options"
            placeholder={state ? t('createAd.searchCity') : t('createAd.selectCity')}
            value={city}
            onChange={(e) => onChange({ ...loc, city: e.target.value })}
            className={`input locationSelect${cityError ? ' cf-input--error' : ''}`}
            disabled={!state}
            autoComplete="off"
          />
          <datalist id="ad-location-city-options">
            {cities.map((c) => (
              <option key={c} value={c} />
            ))}
          </datalist>
          {cityError && <span className="cf-error">{t('createAd.pleaseSelectCity')}</span>}
        </div>
      </div>
      <input
        type="text"
        placeholder={t('createAd.zipCodeOptional')}
        value={pincode}
        onChange={(e) => onChange({ ...loc, pincode: e.target.value })}
        className="input locationPincode"
        maxLength={6}
      />
      <button
        type="button"
        className="locationUseMyLocation"
        onClick={handleUseMyLocation}
        disabled={gettingLocation || geoLoading}
      >
        {gettingLocation || geoLoading
          ? t('createAd.gettingLocation')
          : t('createAd.useMyLocation')}
      </button>
      {geoError && gettingLocation && (
        <span className="locationGeoError">{geoError}</span>
      )}
    </div>
  );
}

export default LocationSelector;
